define([
    "./fetcherModule",
    "./DataFetcherType",
    "./dataFetchers"
], function () {
});